import GameManager from '../../cvp-webgames-core/GameManager';
import BasePracticeScenario from '../base-practice-scenario/BasePracticeScenario';

export default class BaseTestScenario extends BasePracticeScenario {
	constructor(gameManager: GameManager, scenarioName: string) {
        super(gameManager, scenarioName);
        this.isTestScenario = true;
        this.intro.config.isTestScenario = true;
        this.neutralState.config.isTestScenario = true;
        this.procedures.auscultate.config.isTestScenario = true;
        this.procedures.bvm.config.isTestScenario = true;
        this.procedures.cric.config.isTestScenario = true;
        this.procedures.ett.config.isTestScenario = true;
        this.procedures.neutralState.config.isTestScenario = true;
        this.procedures.sga.config.isTestScenario = true;
    }
}